
import React from 'react';

type WhatsAppFloatProps = {
  count?: number;
  size?: number; // pixels
};

const WhatsAppFloat: React.FC<WhatsAppFloatProps> = ({ count = 1, size = 56 }) => {
  const prefill = encodeURIComponent('Olá! Gostaria de receber  mais informações sobre soluções de TI.');
  const href = `https://wa.me/553173565180?text=${prefill}`;

  const iconSize = Math.max(14, Math.round(size * 0.45));

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Abrir conversa no WhatsApp${count ? ` — ${count} novas mensagens` : ''}`}
        title="Abrir conversa no WhatsApp"
        className="relative inline-flex items-center justify-center bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-green-300 transition-transform duration-200"
        style={{ width: size, height: size }}
      >
        <i className="ri-whatsapp-line" style={{ fontSize: iconSize }} aria-hidden />

        
          <span
            aria-hidden
            className="absolute flex items-center justify-center bg-red-500 text-white text-[10px] font-semibold rounded-full ring-2 ring-white"
            style={{ minWidth: 18, height: 18, top: -6, right: -6, padding: '0 4px' }}
          >
             
          </span>
      </a>
    </div>
  );
};

export { WhatsAppFloat };
export default WhatsAppFloat;
